import { mount } from 'svelte';
import './styles/tokens.css';
import './styles/base.css';
import './styles/global.css';
import './lib/messages/common';
import './lib/messages/shell';
import './lib/native';
import App from './App.svelte';
import { registerServiceWorker } from './lib/sw-register';
import { watchForNewVersion } from './lib/version';

watchForNewVersion();

const app = mount(App, { target: document.getElementById('app')! });
registerServiceWorker();

export default app;
